export class Activity {
    public name: string;
    public codeValue: number;
    // activityCode:string;
    // activityName:string;
    // compunds:Compound[];
    public constructor(init: Partial<Activity>) {
        Object.assign(this, init);
    }
}
